// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2f6TC","shimmer":"styles_shimmer__JSYW-","image":"styles_image__EDDz-"};